import React, { useEffect } from "react";
import Meta from "./../../components/Meta";
import ShowSlide from "./../../components/ShowSlide";
import { useRouter } from "next/router";
import { useSlide } from "./../../util/db";
import { useAuth } from "./../../util/auth";
import { createServerSupabaseClient } from "@supabase/auth-helpers-nextjs";

function ShowPage({ slide, slideStatus, ...props }) {
  const router = useRouter();
  const auth = useAuth();

  const { id: slideId } = router.query;

  const isOwner = auth.user && slide?.owner === auth.user.uid;

  if (!slide) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-gray-600">Page not found.</h1>
        </div>
      </div>
    );
  }

  return (
    <>
      <Meta
        title={slide?.title || "Elaborate.ai"}
        image={
          slide
            ? `/api/og?title=${encodeURI(slide?.title)}`
            : "/images/social.png"
        }
      />
      <ShowSlide
        slideId={slideId}
        slide={slide}
        isOwner={isOwner}
        section={router.query.section}
        key={router.query.section}
        searchParams={router.query}
        {...props}
      />
    </>
  );
}

export const getServerSideProps = async (ctx) => {
  const { id } = ctx.params;
  const supabase = createServerSupabaseClient(ctx);
  const {
    data: { session },
  } = await supabase.auth.getSession();
  const { data: slide } = await supabase
    .from("slides")
    .select()
    .eq("id", id)
    .maybeSingle();

  return {
    props: {
      initialSession: session,
      slide,
    },
  };
};

export default ShowPage;
